import { render } from "./BaseEqualizerElement.vue?vue&type=template&id=fc3b5d12"
const script = {}

import exportComponent from "C:\\Projects\\wordpress\\ahrtal-werke\\wp-content\\plugins\\io.shop-ahrtal-werke-lead-solar\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__